module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h11"
  }, [_vm._v("Part One – Autumn")]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('img', {
    attrs: {
      "alt": "img5.png",
      "height": "173",
      "src": "images/img5.png",
      "width": "328"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t16"
  }, [_vm._v("P")]), _c('span', {
    staticClass: "t17"
  }, [_vm._v("ART")]), _c('span', {
    staticClass: "t16"
  }, [_vm._v(" O")]), _c('span', {
    staticClass: "t17"
  }, [_vm._v("NE")])]), _vm._v(" "), _c('p', {
    staticClass: "p11"
  }, [_c('span', {
    staticClass: "t16"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "t17"
  }, [_vm._v("UTUMN")])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b0d06b5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007.vue
// module id = 72
// module chunks = 0